<section class="list">
  <header class="list__header">
    <h2 class="list__title">Requiring your action</h2>
    <a
      mat-button
      color="primary"
      class="list__view-all"
      *ngIf="showViewAll"
      [routerLink]="WebPaths.Submissions"
      [queryParams]="viewAllQuery"
    >
      VIEW ALL
    </a>
  </header>

  <ul class="rows" role="list" *ngIf="rows?.length > 0; else empty">
    <li class="row" *ngFor="let row of rows; trackBy: trackByApplicationId">
      <span
        class="row__badge"
        [class.row__badge--danger]="row.badgeTier === BadgeTier.DANGER"
        [class.row__badge--warning]="row.badgeTier === BadgeTier.WARNING"
        [class.row__badge--neutral]="row.badgeTier === BadgeTier.NEUTRAL"
        attr.aria-label="{{ row.waitDays }} days waiting"
      >
        {{ row.waitDays }}d waiting
      </span>
      <span class="row__name">{{ row.businessName ?? '–' }}</span>
      <span class="row__amount">{{ row.amount | currency: 'USD' : 'symbol' : row.amountDigits }}</span>
      <span class="row__action" [matTooltip]="row.action">{{ row.action }}</span>
    </li>
  </ul>

  <ng-template #empty>
    <p class="list__empty">Nothing needs your action</p>
  </ng-template>
</section>
